<template>
    <v-date-picker v-bind="$attrs" v-on="$listeners" :locale="datePickerLocale" :first-day-of-week="weekStartDay"
        :weekday-format="weekdayLetter" :full-width="fullWidth" no-title :color="resolvedColor"
        :event-color="resolvedEventColor" :picker-date.sync="tableDate" :style="{ '--mc-color': themeColor }"
        :class="['month-calendar', { 'month-calendar--dense': dense }, visibleMonthClass]" />
</template>

<script>
export default {
    name: "MonthCalendar",
    inheritAttrs: false,
    props: {
        month: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: null,
        },
        eventColor: {
            type: String,
            default: null,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            tableDate: this.month,
        }
    },
    computed: {
        defaultColor(vm = this) {
            return vm.$vuetify.theme.dark ? 'primary' : 'secondary'
        },
        resolvedColor(vm = this) {
            return vm.color || vm.defaultColor
        },
        resolvedEventColor(vm = this) {
            return vm.eventColor || vm.defaultColor
        },
        themeColor(vm = this) {
            return vm.$vuetify.theme.currentTheme[vm.resolvedColor] || 'currentColor'
        },
        visibleMonthClass(vm = this) {
            if (!vm.month) return ''
            const [year, month] = vm.month.split('-')
            const visibleYear = String(vm.tableDate || '').split('-')[0]
            if (!month || visibleYear !== year) return ''
            return `month-calendar--m${Number(month)}`
        },
    },
    watch: {
        month(val) {
            const vm = this
            if (val && val !== vm.tableDate) vm.tableDate = val
        },
        tableDate(val) {
            const vm = this
            if (!val || (vm.$attrs.type !== 'month' && /^\d{4}$/.test(val))) return
            if (val === vm.month) return
            vm.$emit('update:month', val)
        },
    },
}
</script>

<style scoped>
.month-calendar.v-picker {
    background: transparent;
    border-radius: 14px;
}

.month-calendar.v-picker--full-width {
    width: 100%;
}

.month-calendar ::v-deep .v-picker__body {
    margin: 0 auto;
    background: transparent;
}

.month-calendar.v-picker--full-width ::v-deep .v-picker__body {
    width: 100% !important;
}

.month-calendar ::v-deep .v-date-picker-header {
    padding: 4px 8px;
}

.month-calendar ::v-deep .v-date-picker-header .v-btn {
    color: var(--v-txtPrimary-base);
}

.month-calendar ::v-deep .v-date-picker-header__value button {
    color: var(--v-txtPrimary-base) !important;
    font-weight: 700;
}

.month-calendar ::v-deep .v-date-picker-table {
    height: auto;
    padding: 0 8px;
    border-bottom: none;
}

.month-calendar ::v-deep .v-date-picker-table th {
    font-weight: 600 !important;
    font-size: 12px !important;
    color: var(--v-txtMuted-base) !important;
}

.month-calendar ::v-deep .v-date-picker-table--date .v-btn {
    width: 34px;
    height: 34px;
    min-width: 34px;
    padding: 0;
    margin: 0 auto;
    border-radius: 50%;
    font-weight: 600;
}

.month-calendar ::v-deep .v-date-picker-table .v-btn--active {
    color: #0C0E12 !important;
    font-weight: 700;
}

.month-calendar ::v-deep .v-btn--active .v-date-picker-table__events > div {
    background: #0C0E12 !important;
}

.month-calendar ::v-deep .v-date-picker-table__events {
    bottom: 6px;
}

.month-calendar ::v-deep .v-date-picker-table__events > div {
    width: 5px;
    height: 5px;
    margin: 0 1px;
}

/* Month being browsed, in the 12-month grid */
.month-calendar--m1 ::v-deep .v-date-picker-table--month tr:nth-child(1) td:nth-child(1) .v-btn,
.month-calendar--m2 ::v-deep .v-date-picker-table--month tr:nth-child(1) td:nth-child(2) .v-btn,
.month-calendar--m3 ::v-deep .v-date-picker-table--month tr:nth-child(1) td:nth-child(3) .v-btn,
.month-calendar--m4 ::v-deep .v-date-picker-table--month tr:nth-child(2) td:nth-child(1) .v-btn,
.month-calendar--m5 ::v-deep .v-date-picker-table--month tr:nth-child(2) td:nth-child(2) .v-btn,
.month-calendar--m6 ::v-deep .v-date-picker-table--month tr:nth-child(2) td:nth-child(3) .v-btn,
.month-calendar--m7 ::v-deep .v-date-picker-table--month tr:nth-child(3) td:nth-child(1) .v-btn,
.month-calendar--m8 ::v-deep .v-date-picker-table--month tr:nth-child(3) td:nth-child(2) .v-btn,
.month-calendar--m9 ::v-deep .v-date-picker-table--month tr:nth-child(3) td:nth-child(3) .v-btn,
.month-calendar--m10 ::v-deep .v-date-picker-table--month tr:nth-child(4) td:nth-child(1) .v-btn,
.month-calendar--m11 ::v-deep .v-date-picker-table--month tr:nth-child(4) td:nth-child(2) .v-btn,
.month-calendar--m12 ::v-deep .v-date-picker-table--month tr:nth-child(4) td:nth-child(3) .v-btn {
    background-color: var(--mc-color) !important;
    color: #0C0E12 !important;
    font-weight: 700;
}

.month-calendar--dense ::v-deep .v-date-picker-table {
    padding: 0 6px;
}

.month-calendar--dense ::v-deep .v-date-picker-table--date .v-btn {
    width: 30px;
    height: 30px;
    min-width: 30px;
    font-size: 12px;
}

.month-calendar--dense ::v-deep .v-date-picker-table__events > div {
    width: 4px;
    height: 4px;
}
</style>
